class ExternalFetch {
    constructor() {
        this.init();
    }

    init() {
        document.querySelectorAll('[data-external-fetch]').forEach((el) => new ExternalFetchItem(el));
    }
}

class ExternalFetchItem {
    constructor(item) {
        this.item = item;
        this.fetchData();
    }

    fetchData() {
        const projectName = this.item.dataset.externalFetch;
        const token = this.item.dataset.externalFetchToken;
        const url = `https://work.sketchpixel.com/api/projects/${encodeURIComponent(projectName)}`;
        const cacheKey = `fetch_${projectName}`;
        const cachedData = sessionStorage.getItem(cacheKey);
        const now = Date.now();

        if (cachedData) {
            const parsedData = JSON.parse(cachedData);
            if (now - parsedData.timestamp < 5 * 60 * 1000) {
                if (parsedData.data) {
                    this.displayData(parsedData.data);
                } else {
                    this.displayEmpty();
                }
                return;
            }
        }

        this.displayLoading();

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.status} - ${response.statusText}`);
                }
                return response.json();
            })
            .then(result => {
                sessionStorage.setItem(cacheKey, JSON.stringify({ data: result.data, timestamp: Date.now() }));
                this.displayData(result.data);
            })
            .catch(error => {
                sessionStorage.setItem(cacheKey, JSON.stringify({ data: null, timestamp: Date.now() }));
                this.displayEmpty();
            });
    }

    displayData(data) {
        if (!data) {
            this.item.innerHTML = `<p class="error">No data found.</p>`;
            return;
        }

        var html = [];

        if (data.percentage_work_completed < 100) {
            html.push(`<div class="item-badges__item item-badges__item--primmary" style="--bg-color: #2d7903">Em progresso</div>`);
        } else if (data.percentage_work_completed >= 100) {
            html.push(`<div class="item-badges__item item-badges__item--primmary" style="--bg-color: #000000">Concluído</div>`);
        }

        if (data.percentage_paid < 100) {
            html.push(`<div class="item-badges__item item-badges__item--secondary" style="--bg-color: #bf0003">Aguardar pagamento</div>`);
        } else if (data.percentage_paid >= 100) {
            html.push(`<div class="item-badges__item item-badges__item--secondary" style="--bg-color: #000000">Pago</div>`);
        }

        this.item.innerHTML = html.join('');
    }

    displayLoading() {
        this.item.innerHTML = `<div class="item-badges__item item-badges__item--secondary" style="--bg-color: #000000">A carregar...</div>`;
    }

    displayEmpty() {
        this.item.innerHTML = ``;
    }
}

export default ExternalFetch;